import { useMemo, useRef, useEffect, useState } from "react";
import { capitalize } from "../../components/Form/Form.js";
import { useColsEffect, useGridRef } from "../../utils/tables.js";
import { dateDiffInMinutes } from "../../utils/date.js";
import DataTablePrime from "../../components/PrimeComponents/DataTablePrime.js";
import { FilterMatchMode } from "primereact/api";
const customAttributes = { class: "customcss" };

const addPrefijo = ({ name, area, showEstimate, kilo_unidad }, t) =>
    `${name}${area ? ` (${showEstimate}${t("general.number", { value: area })} ${kilo_unidad})` : ""}`;

const FarmsTable = ({ fields, t, i18n }) => {
    const tableRef = useRef(null);
    const names = useMemo(() => ["ID", t("general.name"), t("farms.zonesTable.crop"), t("farms.admins"), t("node.cantidadNodos"), t("node.atrasado")], [t]);

    const heightTable = Array.isArray(fields) &&
        (fields.length < 10 ? `${fields.length * 100}px` : "500px");

    const dataSource = useMemo(() => {
        let crop = null;
        return Array.isArray(fields) ? fields.map((f, i) => {
            let adminNames = "";
            if (Array.isArray(f.especie) && f.especie.length > 0) {
                crop = f.especie[0][i18n.language] ?? f.especie[0]["en"];
            }
            else if (f.crops) {
                crop = capitalize(f.crops);
            }
            else {
                crop = "-";
            }

            const husoHorario = f.huso_horario;
            f.nodosAtrasados = 0;
            f.totalNodos = 0;
            f?.nodos?.forEach((nodo) => {
                if (nodo.is_external !== true) {
                    nodo.fecha_ultimo_dato ? nodo.atrasado = dateDiffInMinutes(nodo.fecha_ultimo_dato, husoHorario) >= 180 : nodo.atrasado = null;
                    if (nodo.atrasado === true) f.nodosAtrasados++;
                    f.totalNodos++;
                }
            });
            f.atrasado = f.nodosAtrasados;

            f.administradores && f.administradores.forEach(adm => {
                const nombre = `${adm.nombre} ${adm.apellido_paterno}`;
                adminNames = adminNames !== "" ? adminNames.concat(", ", nombre) : adminNames.concat(nombre);
            });
            f.admin_names = adminNames !== "" ? adminNames : "-";

            f.cultivo_traducido = crop;
            f.nombre_superficie = addPrefijo(f, t);
            return f;
        }) : [];
    }, [fields, t]);

    useEffect(() => {
        if (tableRef.current) {
            const treeGridObj = tableRef.current;
            treeGridObj.setProperties({ columns: treeGridObj.columns, dataSource: dataSource }, !treeGridObj.grid);
        }
    }, [fields, names, t]);
    return (<div>
        <DataTablePrime
            t={t}
            items={dataSource}
            scrollHeight={heightTable}
            header={dataSource.length > 5 ? "search":null}
            filters={{
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            }}
            size="small"
            globalFilterFields={["nombre_superficie", "cultivo_traducido", "admin_names", "totalNodos", "atrasado"]}
            fields={[
                {field:"fertilizante_id",header:names[0], hidden:true, bodyStyle:{textAlign:"center"}},
                {field:"nombre_superficie",header:names[1], bodyStyle:{textAlign:"center"}},
                {field:"cultivo_traducido",header:names[2], bodyStyle:{textAlign:"center"}},
                {field:"admin_names",header:names[3], bodyStyle:{textAlign:"center"}},
                {field:"totalNodos",header:names[4], bodyStyle:{textAlign:"center"}},
                {field:"atrasado",header:names[5], bodyStyle:{textAlign:"center"}},
            ]}
        />
    </div>);
};

const RecordsTable = ({ usersData, t, lng, fields }) => {
    const grid = useRef(null);
    const gridUsers = useRef(null);
    const names = useMemo(() => ["ID", t("farms.farmTable.nameFarm"), t("general.name"), "DropControl", "DropControl APP", t("forms.riegosProgramados"), t("forms.comentariosRealizados")], [lng]);

    const farmCount = {};
    const [selectedRecords, setSelectedRecords] = useState([]);
    usersData.forEach((value) => {
        if(farmCount[value.farmName]){
            farmCount[value.farmName] += 1;
        } else {
            farmCount[value.farmName] = 2;
        }
    });

    function CellEventInfo(args) {
        const colField = args.column.field;
        if (colField === "farmName"){
            if (!grid.current.sortedColumns.length || grid.current.sortedColumns[0] === "farmName"){
                const farmName = args.data.farmName;
                args.rowSpan = farmCount[farmName];
            } else{
                args.rowSpan = 1;
            }
        }
    }

    useColsEffect(grid, names);
    useColsEffect(gridUsers, names);

    const dataSource = useMemo(() => {
        let array = [];
        let currentFarm = null;
        let riegoCount = 0;
        let comentarioCount = 0;
        usersData.forEach((value) => {
            if(value.farmName !== currentFarm){
                if(currentFarm){
                    array = [...array, { "farmName": currentFarm, "usuario": t("forms.total"), "dias_dc": "-", "dias_dc_mobile": "-", "cant_riegos": riegoCount, "cant_comentarios": comentarioCount }];
                }
                currentFarm = value.farmName;
                riegoCount = value.cant_riegos;
                comentarioCount = value.cant_comentarios;
            } else {
                riegoCount += value.cant_riegos;
                comentarioCount += value.cant_comentarios;
            }
            array = [...array, value];
        });
        if(array.length) array = [...array, { "farmName": currentFarm, "usuario": t("forms.total"), "dias_dc": "-", "dias_dc_mobile": "-", "cant_riegos": riegoCount, "cant_comentarios": comentarioCount }];
        return array;

    }, [usersData, fields]);

    const dataSourceUsers = useMemo(() => {
        const userIds = Array.from(new Set(usersData.map(user => {
            return user.usuario_id;
        })));
        let array = [];
        userIds.forEach(userId => {
            const filteredUsers = usersData.filter(user => user.usuario_id === userId);
            const u = filteredUsers[0];
            let riegoCount = 0;
            let comentarioCount = 0;
            filteredUsers.forEach(user => {
                riegoCount += user.cant_riegos;
                comentarioCount += user.cant_comentarios;
            });
            array = [...array, { "usuario_id": u.usuario_id, "usuario": u.usuario, "dias_dc": u.dias_dc, "dias_dc_mobile": u.dias_dc_mobile, "cant_riegos": riegoCount, "cant_comentarios": comentarioCount }];
        });
        return array;
    }, [usersData, fields]);


    const templateDaysDC = ({ dias_dc }) => {
        if (!dias_dc) return 0;
        if (dias_dc === "-"){
            return (
                <a>
                    {dias_dc}
                </a>
            );
        } else {
            return (
                <a>
                    {dias_dc} {t("forms.dias")}
                </a>
            );
        }
    };

    const templateDaysDCAPP = ({ dias_dc_mobile }) => {
        if (!dias_dc_mobile) return 0;
        if (dias_dc_mobile === "-"){
            return (
                <a>
                    {dias_dc_mobile}
                </a>
            );
        } else {
            return (
                <a>
                    {dias_dc_mobile} {t("forms.dias")}
                </a>
            );
        }
    };
    if (!Array.isArray(dataSource)) return null;
    if(fields){
        return(
            <>
                {
                    dataSource.length ?
                        <DataTablePrime
                            t={t}
                            items={dataSource}
                            selectionMode="single"selection={selectedRecords}
                            onSelectionChange={
                                (e) => {
                                    setSelectedRecords(e.value);
                                }
                            }
                            rowGroupMode="rowspan" groupRowsBy="farmName"
                            size="small"
                            fields={[
                                {field:"permiso_id",header:names[0], hidden:true, bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"farmName",header:names[1], bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"usuario",header:names[2], bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"cant_riegos",header:names[5], bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"cant_comentarios",header:names[6], bodyStyle:{textAlign:"center"}, sortable:true},
                            ]}
                        />
                        :<span className='no-data'>{t("forms.noData")}</span>
                }
            </>);
    } else {
        return(
            <>
                {
                    dataSourceUsers.length ?
                        <DataTablePrime
                            t={t}
                            items={dataSourceUsers}
                            selectionMode="single"selection={selectedRecords}
                            onSelectionChange={
                                (e) => {
                                    setSelectedRecords(e.value);
                                }
                            }
                            rowGroupMode="rowspan" groupRowsBy="usuario"
                            size="small"
                            fields={[
                                {field:"permiso_id",header:names[0], hidden:true, bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"usuario",header:names[2], bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"dias_dc",header:names[3], body:templateDaysDC, bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"dias_dc_mobile",header:names[4], vody:templateDaysDCAPP, bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"cant_riegos",header:names[5], bodyStyle:{textAlign:"center"}, sortable:true},
                                {field:"cant_comentarios",header:names[6], bodyStyle:{textAlign:"center"}, sortable:true},
                            ]}
                        />
                        :<span className='no-data'>{t("forms.noData")}</span>
                }
            </>);
    }


};
export { FarmsTable, RecordsTable };
